import * as yup from "yup";

import { type Shape } from "@ds/utils/validation";

export const updateValidationSchema = {
  info: yup.object().shape<Shape<Peripheral>>({}),
};
